const colorPalettes = {
  vibrant: [
    '#D71D1D',
    '#f17917',
    '#e4c81b',
    '#03BF22',
    '#0471D7',
    '#8108d1',
    '#ba31b8',
    '#ed2d7e',
    '#0ddc86',
    '#e80c45',
    '#4389e4',
    '#f3a14e'
  ],
  muted: [
    '#214a7e',
    '#136120',
    '#9a4d10',
    '#52066c',
  ]
}

export function randomColor(colorType) {
  const colorPalette = colorPalettes[colorType]
  const randomIndex = Math.floor(Math.random() * colorPalette.length)
  return colorPalette[randomIndex]
}

